import { render } from "./ClientDocumentFormBlock.vue?vue&type=template&id=42dc536b"
import script from "./ClientDocumentFormBlock.vue?vue&type=script&lang=js"
export * from "./ClientDocumentFormBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__